import React, { useState } from 'react';

import PlanTopHeader from '@/pages/plan/components/PlanTopHeader';
import PlanFormSearch from '@/pages/plan/components/PlanFormSearch';
import PlanList from '@/pages/plan/components/PlanList';

const PlanPage: React.FC = () => {
  const [searchTrigger, setSearchTrigger] = useState(0);

  return (
    <>
      <PlanTopHeader />
      <PlanFormSearch onSearch={() => setSearchTrigger((prev) => prev + 1)} />
      <PlanList searchTrigger={searchTrigger} />
    </>
  )
}

export default PlanPage;